var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import CircleCutout from "../../components/partcreation/circlecutout.vue";
import ModalBase from "../../components/modalbase.vue";
import RectangleCutout from "../../components/partcreation/rectanglecutout.vue";
import SheetMetalProfile from "../../components/partcreation/sheetmetalprofile.vue";
import UserDefinedTube from "../../components/partcreation/userdefinedtube.vue";
import { PartType, } from "../utilities/partcreation";
let PartCreationDialog = class PartCreationDialog extends Vue {
    constructor() {
        super(...arguments);
        this.canBeApplied = true;
        this.partCreationInformation = {
            segments: [],
            name: "",
            thickness: 0.,
            material: {
                name: "",
                identifier: "",
                description: "",
            },
            gasId: "",
        };
        this.tubeCreationInformation = {
            tubeId: "",
            dimX: 0.,
            name: "",
        };
    }
    close() { }
    openPartCreationSelection() { }
    back() {
        this.close();
        this.openPartCreationSelection();
    }
    applyPartCreation() {
        if (!this.networkBroker.queueAddSimplePartRequest(this.partCreationInformation)) {
            return;
        }
        if (!this.networkBroker.queueGraphRequest()) {
            return;
        }
        this.networkBroker.process();
    }
    applyTubeCreation() {
        if (!this.networkBroker.queueAddUserDefinedTubeRequest(this.tubeCreationInformation)) {
            return;
        }
        if (!this.networkBroker.queueGraphRequest()) {
            return;
        }
        this.networkBroker.process();
    }
    apply() {
        if (this.partType === PartType.userDefinedTube) {
            this.applyTubeCreation();
        }
        else {
            this.applyPartCreation();
        }
        this.close();
    }
    addPart() {
        this.apply();
        this.close();
    }
};
__decorate([
    Prop({ required: true })
], PartCreationDialog.prototype, "partType", void 0);
__decorate([
    Prop({ required: true })
], PartCreationDialog.prototype, "shopConfig", void 0);
__decorate([
    Inject()
], PartCreationDialog.prototype, "i18n", void 0);
__decorate([
    Inject()
], PartCreationDialog.prototype, "networkBroker", void 0);
__decorate([
    Emit()
], PartCreationDialog.prototype, "close", null);
__decorate([
    Emit()
], PartCreationDialog.prototype, "openPartCreationSelection", null);
PartCreationDialog = __decorate([
    Component({
        components: {
            CircleCutout,
            ModalBase,
            RectangleCutout,
            SheetMetalProfile,
            UserDefinedTube,
        },
        name: "PartCreationDialog",
    })
], PartCreationDialog);
export default PartCreationDialog;
